import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom/es';
import { LoginPage, PasswordResetConfirmPage, PasswordResetPage, LoginLink, HostAppsPage,TvHostPage, HostAppsPage2, HostPage} from '..';

const AuthRoutes = () => (
  <Switch>
    <Route exact path="/a7" component={HostAppsPage} />
    <Route exact path="/a6" component={HostAppsPage2} />
    <Route exact path="/tv" component={TvHostPage} />
    <Route exact path="/app" component={HostPage} />

    <Route exact path="/forgot-password" component={PasswordResetPage} />
    <Route path="/forgot-password/confirm/:uid/:token" component={PasswordResetConfirmPage} />
    <Route path="/login-for/:code" component={LoginLink} />
    <Route exact path="/login" component={LoginPage} />
    <Redirect from="/" to="/login" />
  </Switch>
);

export default AuthRoutes;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/containers/AuthRoutes/index.js